import apiClient from "./api.client.service";

class ProfileService {
  private APIBaseUrl: string;

  constructor() {
    this.APIBaseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
  }

  async getMatchResultByJobApplicationId(applicationId: string) {
    try {
      const response = await apiClient.get(
        `${this.APIBaseUrl}/admin/profile-matcher?jobApplicationId=${applicationId}`
      );
      return response.data;
    } catch (error) {
      console.error(
        "🚀 ~ ProfileService ~ getMatchResultByJobApplicationId ~ error:",
        error
      );
    }
  }

  async matchResume(jobApplicationId: string, resume: any) {
    const response = await apiClient.post(
      `${this.APIBaseUrl}/admin/profile-matcher`,
      {
        jobApplicationId,
        resume,
      },
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    // Check for soft-error pattern (status: false on HTTP 200)
    if (!response.data?.status) {
      const err = new Error(response.data?.message || 'Profile matching failed') as any;
      err.errorCode = response.data?.errorCode || 'PROFILE_MATCH_FAILED';
      throw err;
    }

    return response.data;
  }
}

const profileService = new ProfileService();
export default profileService;
